// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_array from "../../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Api from "@react-google-maps/api";

function getGoogleConfig(config) {
  var match = config.icon;
  var match$1 = config.anchor;
  return {
          position: config.position,
          clickable: config.clickable,
          visible: config.visible,
          zIndex: config.zIndex,
          icon: match !== undefined && match$1 !== undefined ? ({
                url: match,
                anchor: {
                  x: Caml_array.get(match$1, 0),
                  y: Caml_array.get(match$1, 1)
                }
              }) : undefined,
          onPositionChanged: config.onPositionChanged,
          onMouseOver: config.onMouseOver,
          onMouseOut: config.onMouseOut,
          onClick: config.onClick,
          opacity: config.opacity,
          ref: config.ref
        };
}

function MarkerComponentMod(Props) {
  var lib_nameOpt = Props.lib_name;
  var config = Props.config;
  var children = Props.children;
  var lib_name = lib_nameOpt !== undefined ? lib_nameOpt : /* GoogleMap */0;
  if (lib_name) {
    return null;
  }
  var googleConfig = getGoogleConfig(config);
  return React.createElement(Api.Marker, {
              position: googleConfig.position,
              clickable: googleConfig.clickable,
              visible: googleConfig.visible,
              zIndex: googleConfig.zIndex,
              icon: googleConfig.icon,
              onPositionChanged: googleConfig.onPositionChanged,
              onMouseOver: googleConfig.onMouseOver,
              onMouseOut: googleConfig.onMouseOut,
              onClick: googleConfig.onClick,
              ref: googleConfig.ref,
              children: children
            });
}

var make = MarkerComponentMod;

export {
  getGoogleConfig ,
  make ,
  
}
/* react Not a pure module */
